import React, { useState } from 'react';
import { motion } from 'framer-motion';

const Logo = ({ size = 'default', onClick, className = '' }) => {
  const [isHovered, setIsHovered] = useState(false);

  const sizes = {
    small: { width: 160, height: 30, iconR: 4, textSize: 12, iconX: 12, textX: 24 },
    default: { width: 200, height: 36, iconR: 5, textSize: 15, iconX: 14, textX: 28 },
    large: { width: 260, height: 48, iconR: 6, textSize: 19, iconX: 18, textX: 36 }
  };
  
  const s = sizes[size] || sizes.default;
  
  const SvgContent = (
    <svg 
      width={s.width} 
      height={s.height} 
      viewBox={`0 0 ${s.width} ${s.height}`} 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <defs>
        <radialGradient id={`navGlow-${size}`} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#ff780a" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#ff780a" stopOpacity="0" />
        </radialGradient>
      </defs>
      {/* Soft glow halo */}
      <motion.ellipse 
        cx={s.iconX} 
        cy={s.height * 0.5} 
        rx={s.height * 0.33} 
        ry={s.height * 0.33} 
        fill="#ff780a" 
        animate={isHovered 
          ? { opacity: 0.3, scale: 1.4 } 
          : { opacity: 0.1, scale: 1 }
        }
        transition={{ duration: 0.4, ease: 'easeOut' }}
      />
      {/* Core orb - subtle continuous pulse + hover scale */}
      <motion.circle 
        cx={s.iconX} 
        cy={s.height * 0.5} 
        r={s.iconR} 
        fill="#ff780a"
        animate={isHovered 
          ? { scale: 1.2 } 
          : { scale: [1, 1.06, 1] }
        }
        transition={isHovered 
          ? { duration: 0.3, ease: 'easeOut' } 
          : { duration: 3, repeat: Infinity, ease: 'easeInOut' }
        }
      />
      {/* Inner highlight */}
      <ellipse 
        cx={s.iconX - 1.5} 
        cy={s.height * 0.44} 
        rx={s.iconR * 0.4} 
        ry={s.iconR * 0.3} 
        fill="#FFD4A8" 
        opacity="0.6" 
      />
      {/* Wordmark */}
      <text 
        fontFamily="'DM Serif Display', Georgia, serif" 
        fontSize={s.textSize} 
        letterSpacing="-0.2"
      >
        <tspan x={s.textX} y={s.height * 0.64} fill="#2C2417">remote</tspan>
        <tspan fill="#ff780a">conversations</tspan>
      </text>
    </svg>
  );

  if (onClick) {
    return (
      <motion.button 
        onClick={onClick}
        className="transition-opacity duration-300 hover:opacity-90"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        data-testid="logo"
      >
        {SvgContent}
      </motion.button>
    );
  }

  return SvgContent;
};

export default Logo;
